import React from 'react';
import { Flex, Text, Tag, Icon } from '@chakra-ui/react';
import { FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import { formatDateToHumanDate } from 'common/utils/formDateToHumanTime';
import FormatAsCurrency from 'common/utils/formatAsCurrency';
import { coverageTypeEnum } from 'common/utils/enums';
import { BiSolidBadgeCheck } from 'react-icons/bi';

const CoverageTypeCard = ({
  type,
  coverageData,
  isSelected,
  onSelect,
  lease,
}) => {
  const isLimited = type === coverageTypeEnum.LIMITED;

  const getCardConfig = () => {
    if (isLimited) {
      return {
        title: 'Standard Coverage',
      };
    } else {
      return {
        // icon: BiSolidBadgeCheck,
        title: 'Extended Coverage',
      };
    }
  };

  const config = getCardConfig();

  return (
    <Flex
      className={`border rounded-lg flex-col cursor-pointer transition-all divide-y ${
        isSelected
          ? 'border-blue-500 bg-blue-50 divide-blue-200'
          : 'border-gray-200 hover:border-gray-300 divide-gray-200'
      }`}
      onClick={() => onSelect(type)}
    >
      <Flex className='flex-col gap-2 px-6 py-4 '>
        <Flex className='items-center gap-2 justify-between'>
          <Flex className='flex-col gap-1'>
            <Text className='text-lg font-medium inline-flex items-center gap-3'>
            {config?.icon && (
                <Icon as={config.icon} boxSize={5} className='text-blue-800' />
              )}
              {config.title}              
            </Text>
          </Flex>

          <Flex className='flex-col gap-1'>
            <Text className='text-xl font-medium'>
              {FormatAsCurrency(
                coverageData?.payment?.subscription?.amount *
                  coverageData?.term,
                lease?.currency
              )}
            </Text>
            <Text className='text-sm text-gray-500'>
              {coverageData?.term} months ×{' '}
              {FormatAsCurrency(
                coverageData?.payment?.subscription?.amount,
                lease?.currency
              )}
              /month
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Flex className='flex-row items-center justify-between gap-2 px-6 py-4'>
        <Text className='text-base font-medium'>Coverage Period:</Text>
        <Text className='text-base'>
          {formatDateToHumanDate(coverageData?.startDate)} -{' '}
          {formatDateToHumanDate(coverageData?.endDate)}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CoverageTypeCard;
